import { BasePath } from '@constants/Auth';
import { BRAND_NAME, LOGO_URL } from '@constants/Validation';
import { Trans } from '@lingui/macro';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import { useAuth } from '@swyft/auth';
import React from 'react';

export const DeviceErrorPage = () => {
  const { signOut } = useAuth();
  const classes = useStyles();

  return (
    <Box
      width='100vw'
      minHeight='100vh'
      display='flex'
      justifyContent='center'
      alignItems='center'
      className={classes.errorWrapper}
    >
      <Box width={{ xs: '80%', sm: 500 }} my={4} px={3} py={4} className='shadow-xl border rounded bg-white'>
        <img src={`${BasePath}/${LOGO_URL}`} alt='logo-pipelyne' className='mx-auto h-12' />
        <img src={`${BasePath}/assets/signup.png`} alt='' />
        <Typography variant='body2' className='text-center my-6'>
          <Trans>The {BRAND_NAME} Portal has been optimised for desktop only. </Trans>
        </Typography>
        <Typography variant='subtitle2' className='text-center'>
          <Trans>
            For best experience, we would advise you to switch to a laptop or desktop to begin building your
            questionnaire.
          </Trans>
        </Typography>
        <Button
          color='primary'
          variant='contained'
          className='normal-case font-normal w-40 h-12 shadow-none my-8 block mx-auto'
          onClick={signOut}
        >
          <Trans>Sign Out</Trans>
        </Button>
      </Box>
    </Box>
  );
};
const useStyles = makeStyles({
  errorWrapper: {
    backgroundImage: `url('${process.env.PUBLIC_URL}/assets/Artboard.png')`,
    backgroundSize: 'cover'
  }
});
